import RecordImage from "./RecordImage"
export default RecordImage
